import { NO_VALUE_PLACEHOLDER } from "@/const/default-values"
import { Avatars, type AvatarsProps } from "@/molecules/Avatars"

export const Users: React.FC<AvatarsProps> = (props) => {
  const { list, count, ...rest } = props
  const currentList = list || []
  const currentCount = count ?? currentList.length

  if (!currentCount) return <>{NO_VALUE_PLACEHOLDER}</>

  return (
    <Avatars variant="full" list={currentList} count={currentCount} {...rest} />
  )
}
